<template>
    <div class="share-file dialog-wraper">
        <div v-if="!shareLoading" class="share-wraper">
            <div class="file-share-box">
                <div class="link-body">
                    <div v-if="Onshare" :title="$t('Off')" :class="`share-url select-all nowrap`">{{$t('Off')}}</div>
                    <div v-if="!Onshare" :title="copyData" :class="`share-url select-all nowrap ${error ? 'link-error' : ''}`">{{error || copyData}}</div>
                    <div v-if="Onshare" class="copy-link" @click="share" v-t="'Start'"></div>
                    <div v-if="!Onshare && !error" v-clipboard="copyData" @success="copySuccess" @error="copyError" class="copy-link" v-t="'Copy'"></div>
                    <div v-if="error" class="copy-link" v-t="'Copy'"></div>
                </div>
            </div>
            <div v-if="!Onshare && !error" class="share-permission-wraper">
                <div class="link-permission-box">
                <span v-if="dialogData.sid" class="link-permission link-nowrap nowrap" :title="mode">{{mode}}</span>
                <el-dropdown class="link-nowrap" v-if="!dialogData.sid" trigger="click" placement="bottom-start" @command="(e) => switchTab(e,'viewMode')">
                    <span class="link-permission"><span class="link-permission-tip nowrap" :title="mode">{{mode}}</span><i class="components-icons components-icons-down"><span class="path1"></span></i></span>
                    <el-dropdown-menu 
                        slot="dropdown" 
                        :visible-arrow="false"
                        class="list-actions">
                        <el-dropdown-item command="anyone-view" :class="['list-action-item',viewMode == 'anyone-view' ? 'checked' : '']" >
                            <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Anyone')}}</div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="editable" command="anyone-edit" :class="['list-action-item',viewMode == 'anyone-edit' ? 'checked' : '']">
                            <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Anyedit')}}</div>
                        </el-dropdown-item>
                        <el-dropdown-item
                            command="specific-access" :class="['list-action-item',viewMode == 'specific-access' ? 'checked' : '']">
                            <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Someone')}}</div>
                        </el-dropdown-item>
                        <el-dropdown-item class="list-action-item">
                            <div class="list-action-inner">
                                <span class="stop-share"><div class="list-checked"></div>{{$t('Stopshare')}}</span>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <span class="link-expire">
                    <span class="link-expire-tip nowrap">{{$t('Expire')}}</span>
                    <span v-if="dialogData.sid"  class="link-expire-date" :title="$t(expireTxt)">{{$t(expireTxt)}}</span>

                    <el-dropdown v-if="!dialogData.sid" trigger="click" placement="bottom-end"  @command="(e) => switchTab(e,'expire')">
                        <span class="link-expire-date" :title="$t(expireTxt)">{{$t(expireTxt)}}<i class="components-icons components-icons-down"><span class="path1"></span></i></span>
                        <el-dropdown-menu 
                            slot="dropdown" 
                            :visible-arrow="false"
                            class="list-actions">
                            <el-dropdown-item :command="0" :class="['list-action-item',expire == 0 ? 'checked' : '']">
                                <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Thdays')}}</div>
                            </el-dropdown-item>
                            <el-dropdown-item :command="1" :class="['list-action-item',expire == 1 ? 'checked' : '']">
                                <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Sedays')}}</div>
                            </el-dropdown-item>
                            <el-dropdown-item :command="2" :class="['list-action-item',expire == 2 ? 'checked' : '']">
                                <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Thtdays')}}</div>
                            </el-dropdown-item>
                            <el-dropdown-item :command="3" :class="['list-action-item',expire == 3 ? 'checked' : '']">
                                <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Forever')}}</div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <div class="share-permission-forbid" v-if="!dialogData.sid && !image">
                <el-checkbox :checked="!!download_perm" text-color="#000" @change="(e) => switchTab(e ? 1 : 0,'download_perm')">
                    <span>{{$t("permissionTip")}}</span>
                </el-checkbox>
                
            </div>
            <div class="invite-box" v-if="viewMode == 'specific-access' && !dialogData.sid">
                <div class="invite-entry">
                    <span @click="invite" class="invite-text">
                        <span class="add-icon"><span class="components-icons-box"><i class="components-icons components-icons-add"><span class="path1"></span></i></span></span> {{$t('InivieTip')}}</span>
                    <span class="invited-members">　·　{{members.length}} {{$t('Joined')}}</span>
                </div>
                <div class="link-members-box">
                    <div class="file-share-member-item" v-for="item in members" :key="item.key">
                        <div class="member-avatar-box">
                            <div class="member-avatar avatar-marginRight">
                                <el-tooltip class="item" effect="dark" :content="item.invitee.name" placement="top">
                                    <img :src="item.invitee.avatar" class="el-tooltip item" style="width: 24px; height: 24px;">
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="member-name-box"><div class="nowrap" :title="item.invitee.name" style="cursor: default;">{{item.invitee.name}}</div></div>
                        <div class="member-extension">
                            <!-- <span v-if="!editable" class="member-permission-select">{{$t('view')}}</span> -->
                            <el-dropdown trigger="click" placement="bottom-end" @command="(e) => switchMember(e,item.invitee.id)">
                                <span class="member-permission-select">{{$t(item.permission)}}<span class="components-icons-box"><i class="components-icons components-icons-down"><span class="path1"></span></i></span></span>
                                <el-dropdown-menu 
                                    slot="dropdown" 
                                    :visible-arrow="false"
                                    class="list-actions member-permission">
                                    <el-dropdown-item command="view" :class="['list-action-item',item.permission == 'view' ? 'checked': '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('view')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="editable" command="edit" :class="['list-action-item',item.permission == 'edit' ? 'checked': '']">
                                        <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('edit')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item :class="[`list-action-item`]">
                                        <div class="list-action-inner stop-share"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('Remove')}}</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="share-wraper" v-if="shareLoading" >
            <loading />
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import {share} from '@/store/service/index'
import {updateShare,getMembers,switchPermission,removeMember,getPermission} from '@/store/service/share'
import {editable,shareDomin, ExtMapping} from '@/config'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
            copyData: '',
            shareLoading: true,
            error: '',
            viewMode: '',
            download_perm: 0,
            expire: 3,
            Onshare: false,
            members: [],
            checked: false,
            image: false
        }
    },
    components:{
        Loading
    },
    created(){
        this.doShare()
        this.image = ExtMapping["img"].indexOf(this.dialogIco) >= 0
    },
    computed:{
        ...mapState([
            'dialogData',
            'dialogTitle',
            'dialogIco',
            'extraData',
            'route'
        ]),
        mode(){
            let mode = {
                "anyone-view": this.$t('Anyone'),
                "anyone-edit": this.$t('Anyedit'),
                "specific-access": this.$t('Someone')
            }
            return mode[this.viewMode]
        },
        expireDate(){
            let dates = [3,7,30,0]
            return dates[this.expire]
        },
        expireTxt(){
            let txts = ['Thdays','Sedays','Thtdays','Forever']
            return txts[this.expire]
        },
        editable(){
            return editable.indexOf(this.dialogIco.toLowerCase()) > -1
        }
    },
    methods:{
        ...mapActions('index',[
            'share'
        ]),
        ...mapMutations([
            'SHOW_DIALOG',
            'DIALOG_INIT',
            'SET_EXTRA'
        ]),
        switchTab(e,type){
            this.uploadData(e ? e : 'stopclick')
            if (e != undefined) {
                this[type] = e
                let {fileid,groupid} = this.dialogData
                updateShare({
                    fileid,groupid,access_mode: this.viewMode,validity_term: this.expireDate, download_perm: this.download_perm
                },({status,data}) => {
                    if (status >= 200 && status < 300) {
                        if (this.viewMode == 'specific-access') {
                            this.getContacts()
                        }
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }else{
                
                let {dialogData,viewMode,expire,copyData,dialogIco,dialogTitle,editable} = this
                this.SET_EXTRA({
                    editable
                })
                this.SHOW_DIALOG({
                    title: this.$t('Stopshare'),
                    confirmInfo: this.$t('Stoptip'),
                    current: 'Confirm',
                    smodule: 'index',
                    action: 'stopShare',
                    dialogData: {
                        ...dialogData,
                        dialogIco,
                        dialogTitle,
                        viewMode,expire,copyData,
                        share_link: this.share_link,
                        confirmtxt: this.$t('Stopshare'),
                        close: this.back
                    }
                })
            }
            
        },
        back(){
            let {extraData:{dialogIco,dialogTitle},viewMode,expire,copyData} = this
            this.SHOW_DIALOG({
                current: 'Share',
                size: 'large',
                title: dialogTitle,
                dialogIco,
                dialogData:{
                    ...this.dialogData,
                    link: this.copyData,
                    viewMode,expire,copyData,
                    Onshare: false
                }
            })
        },
        switchMember(permission,invitee){
            let {groupid,fileid} = this.dialogData
            if (permission) {
                switchPermission({
                    groupid,
                    fileid,
                    invitee,
                    permission
                },({status,data}) => {
                    if (status == 200) {
                        let members = this.members.map(item => {
                            item.invitee.id === invitee ? item.permission = permission : ''
                            return item
                        })
                        this.members = members
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }else{
                removeMember({
                    groupid,
                    fileid,
                    invitee
                },({status,data}) => {
                    if (status == 200) {
                        let members = this.members.filter(item => item.invitee.id !== invitee)
                        this.members = members
                        this.SET_EXTRA({
                            members
                        })
                    }else{
                        this.$message.error(this.$t(data.result))
                    }
                })
            }
            
        },
        copySuccess(e){
            this.$message.success(this.$t('Copylink'))
            _dw.onEvent("drive_share_dialog",{
                source: this.route,
                filetype: this.dialogIco,
                action: "show"
            })  
        },
        copyError(){
            this.$message.success(this.$t('Copyerror'))
            this.uploadData("copylink")
        },
        uploadData(action){
            _dw.onEvent("drive_share_dialog",{
                source: this.route,
                filetype: this.dialogIco,
                action
            })
        },
        invite(){
            this.SET_EXTRA({
                editable: this.editable
            })
            this.SHOW_DIALOG({
                current: 'Contact',
                header: true,
                size: 'large',
                title: this.dialogTitle,
                dialogIco: this.dialogIco,
                dialogData:{
                    ...this.dialogData,
                    share_link: this.share_link,
                    link: this.copyData,
                    download_perm: this.download_perm,
                    close: this.back
                }
            })
        },
        share(){
            this.copyData = ''
            this.shareLoading = true
            this.error = ''
            this.viewMode = ''
            this.expire = 3
            this.Onshare = false
            this.members = []
            this.SET_EXTRA({
                members: [],
                updated: true
            })
            this.doShare(true)
        },
        getContacts(){
            if (this.extraData.updated || this.dialogData.sid ) {
                return
            }
            let {groupid,fileid} = this.dialogData
            getMembers({groupid,fileid},({status,data}) => {
                if (status == 200) {
                    this.members = data
                    this.SET_EXTRA({
                        members: data,
                        updated: true
                    })
                }
            })
        },
        async doShare(flag){
             if (this.dialogData.link && !flag) {
                let {viewMode,expire,copyData,link,Onshare,download_perm} = this.dialogData
                this.shareLoading = false
                this.copyData = link
                this.download_perm = download_perm
                this.viewMode = viewMode ? viewMode : ''
                this.expire = typeof expire === 'number' ? expire : 3
                this.Onshare = Onshare
                this.members = this.extraData.members
                if (!this.extraData.updated) {
                    this.getContacts()
                }
                return
            }

            let {fileid,sid,groupid,share_link} = this.dialogData
            if (sid) {
                if (sid.length > 10) {
                    this.copyData = `${share_link || shareDomin + '/d/' + sid}?from=drive \n[${this.$t('File')}] ${this.dialogTitle}.${this.dialogIco}` 
                    getPermission(sid,({status,data}) => {
                        if (status == 200) {
                            let dates = [3,7,30,0]
                            this.expire = dates.indexOf(data.validity_term)
                            this.viewMode = data.access_mode
                        }else{
                            this.error = this.$t(data.result)
                        }
                        this.shareLoading = false
                    })
                }else{
                    this.viewMode = 'anyone-view'
                    this.expire = 3
                    this.copyData = `${share_link || shareDomin + '/d/' + sid}?from=drive \n[${this.$t('File')}] ${this.dialogTitle}.${this.dialogIco}`
                    this.shareLoading = false
                }
                
                return
            }
            let result = await new Promise((resolve) => {
                share({
                    fileid,
                    groupid
                },(res) => {
                    resolve(res)
                })
            })
            if (result.status >= 200 && result.status < 300) {
                let dates = [3,7,30,0]
                this.share_link = result.data.share_link
                this.copyData = `${this.share_link}?from=drive \n[${this.$t('File')}] ${this.dialogTitle}.${this.dialogIco}`
                this.viewMode = result.data.access_mode
                this.expire = dates.indexOf(result.data.validity_term)
                this.download_perm = result.data.download_perm
                if(this.viewMode == 'specific-access'){
                    this.getContacts()
                }
                this.SET_EXTRA({
                    dialogTitle: this.dialogTitle,
                    dialogIco: this.dialogIco
                })
                _dw.onEvent('drive_fileaction_share',{
                    type: 'success'
                })
            }else{
                _dw.onEvent('drive_fileaction_share',{
                    type: 'failed',
                    result: result.data.result
                })
                this.error = this.$t(result.data.result)
            }
            this.shareLoading = false
        }
    },
    watch:{
        shareLoading(cur){
            if(!cur){
                this.uploadData("show")
            }
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/dialog/file/Share.vue